<template>
  <sui-segment attached="bottom">
    <sui-form :error="!!passwordError" @submit.prevent="changePassword()">
      <sui-form-field required>
        <label>Old password</label>
        <sui-input type="password" v-model.trim="oldPassword" autocomplete="current-password" />
      </sui-form-field>
      <sui-form-field required>
        <label>New password</label>
        <div class="row">
          <sui-input type="password" v-model.trim="newPassword" :loading="generatingPassword" autocomplete="new-password" />
          <sui-button icon="refresh" data-inverted data-position="top right" :data-tooltip="tooltipGenerate" @click.prevent="generatePassword()" data-goal="SETTINGS_SECURITY_NEWPASSWORD_GENERATE" />
          <sui-button icon="copy" data-inverted data-position="top right" :disabled="!newPassword" :data-tooltip="tooltipCopy" @click.prevent="copyPassword()" data-goal="SETTINGS_SECURITY_NEWPASSWORD_COPY" />
        </div>
      </sui-form-field>
      <sui-form-field required>
        <label>Confirm new password</label>
        <sui-input type="password" v-model.trim="confirmPassword" :icon="this.confirmPassword ? (isPasswordConfirmed ? 'green check' : 'red ban') : null" autocomplete="new-password" />
      </sui-form-field>
      <sui-message size="mini" positive v-if="passwordSuccess">
        {{passwordSuccess}}
      </sui-message>
      <sui-message size="mini" error v-if="passwordError">
        {{passwordError}}
      </sui-message>
      <sui-form-field>
        <sui-button color="green" :disabled="!oldPassword || !newPassword || !confirmPassword || inProgress" :loading="inProgress" @click.prevent="changePassword()">Change</sui-button>
      </sui-form-field>
    </sui-form>
  </sui-segment>
</template>

<script>
  import api from '@/api'
  import utils from '@/utils'

  export default {
    name: 'SettingsSecurityView',
    data() {
      return {
        inProgress: false,
        passwordSuccess: null,
        passwordError: null,
        generatingPassword: false,
        tooltipGenerate: 'Generate password',
        tooltipCopy: 'Copy password',
        oldPassword: '',
        confirmPassword: '',
        newPassword: '',
      }
    },
    computed: {
      isPasswordConfirmed() {
        return this.newPassword === this.confirmPassword
      },
    },
    methods: {
      generatePassword() {
        if (!this.generatingPassword) {
          this.generatingPassword = true
          this.tooltipGenerate = 'Generating password...'
          setTimeout(() => {
            this.generatingPassword = false
            this.tooltipGenerate = 'Generated!'
            this.newPassword = utils.generatePassword()
            setTimeout(() => {
              this.tooltipGenerate = 'Generate password'
            }, 1000)
          }, 300)
        }
      },
      copyPassword() {
        if (this.newPassword) {
          this.$copyText(this.newPassword).then(() => {
            this.tooltipCopy = 'Copied!'
          }, () => {
            this.tooltipCopy = 'Can\'t copy!'
          })
          setTimeout(() => {
            this.tooltipCopy = 'Copy password'
          }, 1000)
        }
      },
      changePassword() {
        this.passwordError = null
        this.passwordSuccess = null
        if (!this.isPasswordConfirmed) {
          this.passwordError = 'New password and confirmation password do not match'
          return
        }
        utils.reachGoal('SETTINGS_SECURITY_NEWPASSWORD_TRY')
        this.inProgress = true
        api.changeUserPassword({oldPassword: this.oldPassword, password: this.newPassword})
          .then(() => {
            utils.reachGoal('SETTINGS_SECURITY_NEWPASSWORD_SUCCESS')
            this.oldPassword = ''
            this.newPassword = ''
            this.confirmPassword = ''
            this.passwordSuccess = 'The password is successfully changed'
          })
          .catch(error => {
            utils.reachGoal('SETTINGS_SECURITY_NEWPASSWORD_FAIL')
            this.passwordError = error;
          })
          .finally(() => {
            this.inProgress = false
          })
      },
    },
  }
</script>

<style scoped>
  .row { display: flex; }
  .row .button { margin: 0 0 0 1em!important; }
  .row .button + .button { margin: 0 0 0 .3em!important; }
</style>
